import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import size from 'lodash/size';
import flatMap from 'lodash/flatMap';
import filter from 'lodash/filter';
import {FormattedMessage, injectIntl} from "react-intl";

import {
  removeFromCart,
  toggleSelectionWindow,
  changeStateToQuote,
  setQtActiveCategory,
  changeActivePartRelatedItemIndex
} from "../../actions/actionFunctions";
import {
  getCurrencySign,
  getFeatureGroupName, getPriceWithCurrency,
  getRoomName,
  getTotalPrice,
  toFixedPrice
} from "../../misc/helpers";
import Analytics from './../../analytics';
import CommonFeatureItemsMethods from "../visComponents/commonFeatureItemsMethods";
import ChangeRoomButton from "./changeRoomButton";
import ShoppingCartItemsListItem from "./shoppingCartItemsListItem";
import {getCurrentLayout} from "../appLayout";
import {changeQTRoutePath, changeRoutePath} from "../../misc/changeRoutePath";
import ShoppingCartDiscountsList from "./shoppingCartDiscountsList";
import ShoppingCartItemsListInstallationItem from "./shoppingCartItemsListInstallationItem";
import AdvancedQuotingList from "./advancedQuoting/advancedQuotingList";
import {setActiveQuoteIndex} from "../../actions/roomsFunctions";
import SimilarProducts from "./similarProducts/similarProducts";
import {SQFT_CHILD_FEATURE_GROUP_PART_IDS, SQFT_FEATURES} from "../sqft/constants";
import {
  getAvailableSteps,
  getCorrectedWizardGroupId,
  showWizardInsteadOfQT
} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {WIZARD_GROUP_TYPES} from "../../interfaces/wizardItemInterface";
import ShoppingCartItemsListWizardCustomItem from "./shoppingCartItemsListWizardCustomItem";
import {setNewActiveQuote} from "../../misc/quotesFunctions";
import LoadingSpinner from "../ui/loadingSpinner";
import {getDifferentCurrencyCartItems} from "../../misc/misc2";
import {switchToNewVisualizerType} from "../../misc/visualizerSwitchingFunctions";
import goToMaterialPage from "../common/goToMaterialPage";
import {
  getWizardGroupName,
  isSameVisualizerWizard
} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import TextInput from "../ui/textInput";
import {shouldUseMultipleWorkSheets} from "../priceWorksheet/discountFunctions";
import ShoppingCartRoomMultiplierInput from "./ShoppingCartRoomMultiplierInput";
import {getCommonVisualizerType} from "../../config";


class ShoppingCartItemsList extends CommonFeatureItemsMethods {

  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    this.props.changeStateToQuote();
  }

  shouldComponentUpdate(nextProps) {
    return !nextProps.showAssignQuotePopup && !nextProps.jobIsSaving;
  }

  switchToMaterialsPageGroup = async (listItem, quoteIndex, cartItem = null) => {
    const {selectionGroup, featureGroupName, featureGroup} = listItem;
    Analytics.sendClickEvent(cartItem ? "shopping-cart-edit-feature" : "shopping-cart-items-go-to-materials");
    const {activeQuoteIndex, setActiveQuoteIndex} = this.props;
    if (cartItem && (cartItem.fromVisualizerType !== document.kvConfig.visualizerType)) {
      await switchToNewVisualizerType(cartItem.fromVisualizerType);
      // this.props.setActionAfterVisualizerTypeIsChanged();
    }
    if (quoteIndex !== activeQuoteIndex) {
      await setNewActiveQuote(quoteIndex);
      await setActiveQuoteIndex(quoteIndex);
    }
    if (featureGroup) {
      // const switchToProduct = cartItem.relatedProductParent || cartItem.cartFeature;
      let wizardAllObject = null;
      let stepIndex = 0;
      if (cartItem && cartItem.fromWizardId) {
        wizardAllObject = {wizardItemId: cartItem.fromWizardId, quoteIndex};
        stepIndex = cartItem.fromWizardStep;
      }
      goToMaterialPage("shoppingcart", false, {part: featureGroup}, "", wizardAllObject, stepIndex);
      return
    }
    const layout = getCurrentLayout();
    if (layout.qtCategories) {
      let subPartIndex = 0;
      const neededQtCat = layout.qtCategories.find(qtCat => {
        const sIndex = qtCat.defaultSubParts.findIndex(sPart => {
          return (sPart.part.customGroupDisplayName || sPart.text) === featureGroupName
        })
        if (sIndex > -1) {
          subPartIndex = sIndex
          return true
        }
        return false
      }) || layout.qtCategories[0];
      this.props.setQtActiveCategory(neededQtCat.name);
      this.props.changeActivePartRelatedItemIndex(subPartIndex);
      changeQTRoutePath(neededQtCat.name, subPartIndex);
    } else {
      this.props.toggleSelectionWindow(true, selectionGroup);
      const parentGroup = layout.parts[selectionGroup];
      if (parentGroup) {
        const subPartIndex = parentGroup.subParts().findIndex(sPart => {
          return (sPart.part.customGroupDisplayName || sPart.text) === featureGroupName
        })
        changeRoutePath(parentGroup, subPartIndex > -1 ? subPartIndex : 0)
      } else {
        hashHistory.push('materials');
      }
    }
  };

  setFeatureGroupCustomName = (featureGroup, quoteIndex = 0, value) => {
    if (!featureGroup.customNames) {
      featureGroup.customNames = {}
    }
    featureGroup.customNames[quoteIndex] = value;
    this.forceUpdate();
  }

  createCommonParentsList = () => {
    const {quotes, cartItems, activeQuoteIndex, showAllQuotesCartItemsList, intl, fabricatorData, wizardList,
        wizardIsActive, allWizardsValues} = this.props;
    const isWizard = showWizardInsteadOfQT(wizardList, wizardIsActive);
    let quotesList = {}; // {quoteIndex: ArrayOf({parentName: "", cartItem})}
    quotes.forEach((quote, quoteIndex) => {

      const layout = getCurrentLayout(fabricatorData.settings.allowVisualizerSwitching && quote.room ? quote.room : document.kvConfig.visualizerType);

      const cartList = []; //ArrayOf({parentName: "", cartItem})
      const quoteCartItems = cartItems.filter((cartItem) => cartItem.cartFeature && (cartItem.currentQuote === quoteIndex));
      if (showAllQuotesCartItemsList || quoteIndex === activeQuoteIndex) {
        let uniqueCartItemIds = [];

        const addToCartList = (cartItem, wizardGroup, wizardItemId) => {
          //todo get slab parentGroup and remove displayFakeFeatureGroupName
          const parentGroup = cartItem.cartFeature.getParent
            ? cartItem.cartFeature.getParent()
            : layout.getFeatureGroupByPartId(cartItem.cartFeature.partId);
          const isSlabCartItem = cartItem.partId === SQFT_FEATURES.slabs
            || cartItem.displayFakeFeatureGroupName === SQFT_FEATURES.slabs;
          let featureGroupName;
          let featureGroupDisplayName;

          if (cartItem.displayFakeFeatureGroupName) {
            featureGroupName = cartItem.displayFakeFeatureGroupName;
            featureGroupDisplayName = intl.formatMessage({id: "sqftFeaturesPopup.title."  + cartItem.displayFakeFeatureGroupName});
          } else {
            featureGroupName = parentGroup ? parentGroup.customGroupDisplayName || parentGroup.partName : cartItem.selectionGroup;
            if (wizardGroup) {
              featureGroupDisplayName = getWizardGroupName(wizardGroup);
            }
            if (!featureGroupDisplayName || !wizardGroup) {
              featureGroupDisplayName = parentGroup ? getFeatureGroupName(parentGroup, intl, fabricatorData) : cartItem.selectionGroup;
            }
          }

          const parent = cartList.find(listItem => {
            if (listItem.featureGroupName !== featureGroupName) {
              return null // for slab <-> backspash mismatch
            }
            if (isSlabCartItem) {
              return true;
            }
            if (isWizard && cartItem.fromWizardGroupId) {
              const existingItem = (listItem.wizardItemId === cartItem.fromWizardId) && (listItem.wizardGroupId === cartItem.fromWizardGroupId || (
                wizardGroup && wizardGroup.mergedGroups
                && (wizardGroup.mergedGroups.some(wizG => wizG.id === cartItem.fromWizardGroupId))
                && (wizardGroup.mergedGroups.some(wizG => wizG.id === listItem.wizardGroupId))
              ))
              return existingItem
            }
            return listItem.featureGroupName === featureGroupName
          });
          if (parent) {
            parent.cartItems.push(cartItem);
          } else {
            cartList.push({
              featureGroupName,
              featureGroupDisplayName,
              selectionGroup: cartItem.selectionGroup,
              cartItems: [cartItem],
              featureGroup: parentGroup,
              wizardGroupId: wizardGroup ? wizardGroup.id : null,
              wizardItemId,
            });
          }
        };

        if (isWizard) {
          const boxesArray = quoteCartItems.filter((cItem) => cItem.partId.endsWith("_boxes"));
          const commonVisualizerType = quotes[quoteIndex] ? getCommonVisualizerType(quotes[quoteIndex].room) : getCommonVisualizerType();

          wizardList.forEach(wizardItem => {
            if (fabricatorData.settings.allowVisualizerSwitching
              && !isSameVisualizerWizard(wizardItem, commonVisualizerType)) {
              return null
            }
            const existingAllObject = allWizardsValues.find(wizardsSelectedObject => {
              return wizardsSelectedObject.quoteIndex === quoteIndex && (wizardsSelectedObject.wizardItemId === wizardItem.id)
                && isSameVisualizerWizard(wizardsSelectedObject, commonVisualizerType)
            }) || {quoteIndex, wizardItemId: wizardItem.id, visualizer: getCommonVisualizerType(), wizardSelectedValues: {}};

            const wizardSelectedValues = existingAllObject.wizardSelectedValues;

            const wizardSteps = getAvailableSteps(wizardItem, wizardSelectedValues, true);
            wizardSteps.forEach(wizardStep => {
              const wizardGroup = getCorrectedWizardGroupId(wizardStep.stepGroups,  wizardSelectedValues[wizardStep.stepIndex])[0];
              if (!wizardGroup) {
                return null
              }
              if (existingAllObject.wizardSelectedValues[wizardStep.stepIndex]) {
                if (wizardGroup && wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom && !wizardGroup.hideInCartAndReceipt) {
                  cartList.push({
                    type: WIZARD_GROUP_TYPES.custom,
                    wizardSelectedValue: existingAllObject.wizardSelectedValues[wizardStep.stepIndex],
                    wizardAllObject: existingAllObject,
                    stepIndex: wizardStep.stepIndex,
                    wizardGroup,
                  });
                  return
                }
              }
              let currentCartItems = cartItems.filter(cartItem => {
                if (cartItem.bundleParentId) {
                  return false
                }
                return cartItem.cartFeature && (cartItem.currentQuote === quoteIndex)
                  && cartItem.fromWizardId && (cartItem.fromWizardId === wizardItem.id)
                  && (wizardGroup && cartItem.fromWizardGroupId
                    ? ((wizardGroup.id === cartItem.fromWizardGroupId)
                      || (wizardGroup.mergedGroups && wizardGroup.mergedGroups.some(wizG => wizG.id === cartItem.fromWizardGroupId)))
                    : +wizardStep.stepIndex === cartItem.fromWizardStep)
                  && !uniqueCartItemIds.includes(cartItem.id) && !cartItem.partId.endsWith("_boxes")
              });
              if (currentCartItems.length) {
                uniqueCartItemIds = [...uniqueCartItemIds, ...currentCartItems.map(cItem => cItem.id)];
                currentCartItems.forEach((cartItem) => addToCartList(cartItem, wizardGroup, wizardItem.id));

                if (SQFT_CHILD_FEATURE_GROUP_PART_IDS[currentCartItems[0].partId]) {
                  boxesArray.forEach(cItem => {
                    if (!cItem.bundleParentId && cItem.cartFeature && (cItem.currentQuote === quoteIndex)
                      && cItem.partId === SQFT_CHILD_FEATURE_GROUP_PART_IDS[currentCartItems[0].partId]
                      && !uniqueCartItemIds.includes(cItem.id)) {
                      uniqueCartItemIds = [...uniqueCartItemIds, cItem.id];
                      addToCartList(cItem); // add without current wizard group, it is always Boxes In the Name
                    }
                  })
                }

                // } else if (wizardGroup && !wizardGroup.hideInCartAndReceipt) {
                //   cartList.push({
                //     type: WIZARD_GROUP_TYPES.custom,
                //     wizardSelectedValue: existingAllObject.wizardSelectedValues[key],
                //     wizardAllObject: existingAllObject,
                //     stepIndex: key,
                //     wizardGroup,
                //   });
              }
            })
          });
          quoteCartItems.forEach((cartItem) => {
            if (!uniqueCartItemIds.includes(cartItem.id) && !cartItem.bundleParentId && !cartItem.partId.endsWith("_boxes")) {
              uniqueCartItemIds.push(cartItem.id);
              addToCartList(cartItem);
              if (SQFT_CHILD_FEATURE_GROUP_PART_IDS[cartItem.partId]) {
                boxesArray.forEach(cItem => {
                  if (!cItem.bundleParentId && cItem.partId === SQFT_CHILD_FEATURE_GROUP_PART_IDS[cartItem.partId]
                    && !uniqueCartItemIds.includes(cItem.id)) {
                    uniqueCartItemIds.push(cItem.id);
                    addToCartList(cItem)
                  }
                })
              }
            }
          });
          boxesArray.forEach((cartItem) => {
            if (!uniqueCartItemIds.includes(cartItem.id) && !cartItem.bundleParentId) {
              uniqueCartItemIds.push(cartItem.id);
              addToCartList(cartItem)
            }
          });
        } else if (layout.qtCategories) {
          layout.qtCategories.forEach(qtCategory => {
            qtCategory.subParts.forEach((subPart) => {
              let currentCartItems = cartItems.filter(cartItem => {
                if (cartItem.bundleParentId) {
                  return false
                }
                return cartItem.cartFeature && (cartItem.currentQuote === quoteIndex)
                  && (subPart.part.partId === cartItem.partId || (cartItem.relatedProductParent && subPart.part.partId === cartItem.relatedProductParent.partId))
                  && !uniqueCartItemIds.includes(cartItem.id)
              });
              if (currentCartItems.length) {
                uniqueCartItemIds = [...uniqueCartItemIds, ...currentCartItems.map(cItem => cItem.id)];
                currentCartItems.forEach((cartItem) => addToCartList(cartItem))
              }
            })
          });
          quoteCartItems.forEach((cartItem) => {
            if (!uniqueCartItemIds.includes(cartItem.id) && !cartItem.bundleParentId) {
              uniqueCartItemIds.push(cartItem.id);
              addToCartList(cartItem)
            }
          })
        } else {
          quoteCartItems.forEach((cartItem) => addToCartList(cartItem))
        }
        cartList.push({
          type: "similar",
          quoteIndex
        });
        if (showAllQuotesCartItemsList) {
          cartList.push({
            type: "subTotal",
            quoteIndex
          });
        }
      }
      // const priorityOrder = {
      //   'Top Cabinet': 1,
      //   'Upper Cabinet Boxes': 2,
      //   'Bottom Cabinet': 3,
      //   'Lower Cabinet Boxes': 4
      // };
      //
      // const sortedCartList = cartList.slice().sort((a, b) => {
      //   const aName = a.featureGroupDisplayName;
      //   const bName = b.featureGroupDisplayName;
      //
      //   const aPriority = priorityOrder[aName] ? priorityOrder[aName] : 999;
      //   const bPriority = priorityOrder[bName] ? priorityOrder[bName] : 999;
      //
      //   return aPriority - bPriority;
      // });

      // console.log("cartList", cartList);
      quotesList[quoteIndex] = cartList
    });
    // console.log("quotesList", quotesList);
    return quotesList
  };

  getCartItemsList = (isMobile, fabricatorData, fabricatorSettings) => {
    const {cartItems, showAllQuotesCartItemsList, isPhoneNumberValidated, quotes, intl} = this.props;
    if (!cartItems.length) {
      // if (!cartItems.length || (Object.keys(quotesList).every(quoteIndex => !quotesList[quoteIndex].length))) {
      return (
        <h3 className="scart-noitems">
          <FormattedMessage id="shoppingCart.noItemsAddedToTheCart"/>
        </h3>
      )
    }
    const quotesList = this.createCommonParentsList();
    const quotesListArray = Object.keys(quotesList);

    const {isBackend, jobId, canSaveQuote} = document.kvConfig;
    const pricingIsLocked = (fabricatorSettings.leadCaptureOnQuote || fabricatorSettings.leadCaptureShoppingCart)
      && !(isBackend && jobId && canSaveQuote) && !isPhoneNumberValidated;

    return quotesListArray.map(quoteIndex => {
      return (
        <div className={"scart-room" + (showAllQuotesCartItemsList && (quotesListArray.length > 1)  ? " scart-room--bordered" : "")} key={quoteIndex}>
          {showAllQuotesCartItemsList && (quotesListArray.length > 1) ? (
            <h4 className="scart-block__title-room bold">
              <FormattedMessage id="shoppingCart.roomTitle"/>: {getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData)}
            </h4>
          ) : null}
          {quotesList[quoteIndex].map((listItem, index) => {
            if (this.props.showUnlockCalculations && listItem.cartItems && !listItem.cartItems.some(cartItem => {
              return this.props.showCartItems.includes(cartItem.id)
            })) {
              return false
            }
            if (listItem.type === "subTotal") {
              const quoteTotalPrice = getTotalPrice(listItem.quoteIndex, false);
              if (fabricatorData.isAmericanImport || this.props.hideTotalPricesBeforeWSOpened || (this.props.showUnlockCalculations && (this.props.unlockCalculationsStep < 2))) {
                return null
              }
              const quoteCartItems = fabricatorSettings.useDifferentCurrencies ? cartItems.filter(cartItem => cartItem.currentQuote === listItem.quoteIndex) : [];
              const differentCurrencyObjects = getDifferentCurrencyCartItems(fabricatorSettings, quoteCartItems);
              const multiplier = quotes[quoteIndex].roomMultiplier;

              return (
                <div className={"scart-block" + (differentCurrencyObjects.length ? " flex flex--end" : "")} key={index}>
                  {differentCurrencyObjects.length ? differentCurrencyObjects.map(currObject => {
                    const currentTotal = getTotalPrice(listItem.quoteIndex, false, currObject.cartItems);
                    return (
                      <div key={currObject.currency + listItem.quoteIndex}
                           className={"scart-block__subtotal" + (
                             quotesList[quoteIndex].every(listItem => listItem.type === "subTotal") ? " scart-block__subtotal--only" : ""
                           )}>
                        <span className="scart-block__subtotal-text">
                          <FormattedMessage id="shoppingCart.totalColumnsSubTotal"/>
                          {multiplier > 1 ? `(x${multiplier})` : ":"}
                        </span>
                        {pricingIsLocked ? (
                          <span className="price price--locked">
                            <FormattedMessage id="shoppingCart.totalColumnsTotalPricingLocked"/>
                          </span>
                        ) : getCurrencySign(currObject.currency, fabricatorSettings) + toFixedPrice(currentTotal.materialPrice, true)}
                      </div>
                    )
                  }) : null}
                  <div className={"scart-block__subtotal" + (
                    quotesList[quoteIndex].every(listItem => listItem.type === "subTotal") ? " scart-block__subtotal--only" : ""
                  )}>
                    <span className="scart-block__subtotal-text">
                      <FormattedMessage id={multiplier > 1 ? "shoppingCart.totalColumnsRoomTotal" : "shoppingCart.totalColumnsSubTotal"}/>:
                    </span>
                    {pricingIsLocked ? (
                      <span className="price price--locked">
                        <FormattedMessage id="shoppingCart.totalColumnsTotalPricingLocked"/>
                      </span>
                    ) : getPriceWithCurrency(fabricatorSettings, toFixedPrice(quoteTotalPrice.materialPrice / (multiplier || 1)))}
                  </div>
                  {multiplier > 1 && !pricingIsLocked ? (
                    <div className={"scart-block__subtotal" + (
                      quotesList[quoteIndex].every(listItem => listItem.type === "subTotal") ? " scart-block__subtotal--only" : ""
                    )}>
                      <span className="scart-block__subtotal-text">{multiplier > 1 ? `x${multiplier}:` : ":"}</span>
                      {getPriceWithCurrency(fabricatorSettings, toFixedPrice(quoteTotalPrice.materialPrice))}
                    </div>
                  ) : null}
                </div>
              )
            } else if (listItem.type === "similar") {
              return <SimilarProducts quoteIndex={+quoteIndex} key={index}/>
            } else if (listItem.type === WIZARD_GROUP_TYPES.custom) {
              return <ShoppingCartItemsListWizardCustomItem quoteIndex={+quoteIndex} listItem={listItem} key={index}/>
            }
            const isAddMoreDisabled = listItem.featureGroupName === SQFT_FEATURES.slabs;

            const editFeatureGroupClick = (event, editCartItem = null) => {
              if (!editCartItem && listItem.cartItems.length && listItem.cartItems[0].fromWizardId) {
                editCartItem = listItem.cartItems[0];
              }
              this.switchToMaterialsPageGroup(listItem, +quoteIndex, editCartItem)
            }
            // console.log("listItem", listItem);
            return (
              <div className="scart-block" key={index}>
                <div className="scart-block__title flex flex--center flex--start">
                  {document.kvConfig.isBackend && listItem.featureGroup
                    ? <TextInput className={"price-input price-input--auto"}
                                 onChange={(value) => this.setFeatureGroupCustomName(listItem.featureGroup, quoteIndex, value)}
                                 value={listItem.featureGroup.customNames && listItem.featureGroup.customNames[quoteIndex]
                                   ? listItem.featureGroup.customNames[quoteIndex]
                                   : listItem.featureGroupDisplayName}/>
                    : listItem.featureGroupDisplayName}
                  {listItem.featureGroup.partId === "room" ? <ShoppingCartRoomMultiplierInput quoteIndex={quoteIndex}
                                                                                              className={"u-ml-05"}/> : null}
                </div>
                {
                  isAddMoreDisabled
                    ? null
                    : <button className="scart-block__add-more" onClick={editFeatureGroupClick}>
                        <FormattedMessage id="shoppingCart.addMoreItemsToTheCart"/>
                      </button>
                }
                <ul className={"scart-block__list"
                + (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser && !isMobile ? " scart-block__list--with-price" : "")}>
                  {listItem.cartItems.map((cartItem, index2) => {
                    return <ShoppingCartItemsListItem featureGroup={listItem.featureGroup}
                                                      cartItem={cartItem}
                                                      key={index2}
                                                      editFeatureGroupClick={editFeatureGroupClick}/>
                  })}
                </ul>
              </div>
            );
          })}
          {this.props.hasMultipleWorkSheets && quotesList[quoteIndex].length
            ? <ShoppingCartDiscountsList hasMultipleWorkSheets={true}
                                         quoteIndex={+quoteIndex}/>
            : null}
        </div>
      )
    })
  };

  getInstallations = (isMobile, fabricatorData, fabricatorSettings, installations) => {

    const showInstallations = size(installations) && fabricatorSettings.separateLaborInCart
      && (!this.props.showUnlockCalculations || (this.props.unlockCalculationsStep >= 2));

    if (showInstallations) {
      return (
        <div className="scart-block" key='Installations'>
          <h3 className="scart-block__title" data-title='Installations'>
            <FormattedMessage id="shoppingCart.installationsTitle"/>
          </h3>
          <ul className={"scart-block__list"
            + (fabricatorSettings.showPricing && !fabricatorData.hideCheckoutBreakdownCost && !fabricatorData.hidePricesFromUser && !isMobile ? " scart-block__list--with-price" : "")}>
            {installations.map((instItem, instItemIndex) => {
              return <ShoppingCartItemsListInstallationItem instItem={instItem} isMobile={isMobile} key={instItemIndex}/>
            })}
          </ul>
        </div>
      )
    }
    return null
  };

  getTaxes = (isMobile, totalPrice, fabricatorSettings, sureTaxLoading) => {
    if (isMobile && this.props.cartItems.length && this.props.isPhoneNumberValidated) {

      if (sureTaxLoading) {
        return (
          <div className="scart-block">
            <h3 className="scart-block__title"><FormattedMessage id="shoppingCart.taxesTitle"/></h3>
            <ul className="scart-block__list">
              <li className="scart-block__list-item">
                <div className="scart-block__list-item-text">
                  <div className="scart-block__list-item-text-price">
                    <LoadingSpinner size="smaller"/>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        )
      }

      let allTaxes = totalPrice.priceTaxes.length
        ? totalPrice.priceTaxes
        : [{name: "", materialTax: totalPrice.materialTaxes}];

      const showTaxes = allTaxes.some(tax => tax.materialTax > 0);

      return (
        <Fragment>
          {showTaxes || ((allTaxes.length === 1) && fabricatorSettings.sureTax) ? allTaxes.map((taxObject, taxObjectIndex) => {
            const taxTotal = taxObject.materialTax.toFixed(2); // always round to 23.65, even if it is 23.00
            return (
              <div className="scart-block" key={taxObjectIndex}>
                <h3 className="scart-block__title">{taxObject.state || <FormattedMessage id="shoppingCart.taxesTitle"/>}</h3>
                <ul className="scart-block__list">
                  <li className="scart-block__list-item">
                    <div className="scart-block__list-item-text">
                      <div className="scart-block__list-item-text-price">
                        <span className="scart-block__list-item-text-price-number">
                          {getPriceWithCurrency(fabricatorSettings, taxTotal)}
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            )
          }) : null}
          {totalPrice.installationTaxes ? (
            <div className="scart-block">
              <h3 className="scart-block__title"><FormattedMessage id="shoppingCart.installationTaxesTitle"/></h3>
              <ul className="scart-block__list">
                <li className="scart-block__list-item">
                  <div className="scart-block__list-item-text">
                    <div className="scart-block__list-item-text-price">
                    <span className="scart-block__list-item-text-price-number">
                      {getPriceWithCurrency(fabricatorSettings, totalPrice.installationTaxes.toFixed(2))}
                    </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          ) : null}
        </Fragment>
      )
    }
    return null
  };

  render() {

    const isMobile = this.props.windowWidth < 991;
    const totalPrice = getTotalPrice();
    const {fabricatorData, installations, showAdvancedQuoting, sureTaxLoading, cartItems, hasMultipleWorkSheets,
      hideTotalPricesBeforeWSOpened} = this.props;
    const fabricatorSettings = fabricatorData.settings;

    console.log("this.props.cartItems", this.props.cartItems);

    return (
      <div className={"scart-content__list" + (this.props.questionNoClicked ? " scart-content__list--translate" : "")}>
        {showAdvancedQuoting ? <AdvancedQuotingList/> : this.getCartItemsList(isMobile, fabricatorData, fabricatorSettings)}
        {this.getInstallations(isMobile, fabricatorData, fabricatorSettings, installations)}
        {this.getTaxes(isMobile, totalPrice, fabricatorSettings, sureTaxLoading)}
        {cartItems.length && !hasMultipleWorkSheets && !hideTotalPricesBeforeWSOpened ? <ShoppingCartDiscountsList/> : null}
        {document.kvConfig.initialFlowEnabled ? <ChangeRoomButton/> : null}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const installations = flatMap(store.instState.instList, i => filter(i.services, {selected: true}));
  const {wizardList, wizardIsActive, allWizardsValues} = store.wizardState;
  const {sureTaxLoading, hideTotalPricesBeforeWSOpened} = store.cartState;
  const {jobIsSaving, windowWidth} = store.serverState;

  return {
    cartItems: store.cartState.cartItems,
    installations,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    layoutParts: store.stepsState.layoutParts,
    questionNoClicked: store.cartState.questionNoClicked,
    windowWidth,
    fabricatorData: store.fabricatorState,
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    unlockCalculationsStep: store.unlockCalculationsState.unlockCalculationsStep,
    showCartItems: store.unlockCalculationsState.showCartItems,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    quotes: store.quotesState.quotes,
    showAllQuotesCartItemsList: store.cartState.showAllQuotesCartItemsList,
    showAdvancedQuoting: store.advancedQuotingState.showAdvancedQuoting,
    wizardList,
    wizardIsActive,
    allWizardsValues,
    showAssignQuotePopup: store.assignQuoteState.showAssignQuotePopup,
    sureTaxLoading,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(store.priceWorksheetState.workSheetsCount),
    jobIsSaving,
    hideTotalPricesBeforeWSOpened,
  }
};

const mapDispatchToProps = {
  removeFromCart,
  toggleSelectionWindow,
  changeStateToQuote,
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  setActiveQuoteIndex
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartItemsList)
);
